import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthContext";
import AuthShell from "../components/AuthShell";
import CampoPassword from "../components/CampoPassword";

const ESTRATEGIAS = ["♿ RBC", "🧓 Vejez", "🏙️ Habitante de Calle", "🧭 Migrante"];

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [identificacion, setIdentificacion] = useState("");
  const [password, setPassword] = useState("");
  const [enviando, setEnviando] = useState(false);

  async function manejarSubmit(e) {
    e.preventDefault();
    setEnviando(true);
    try {
      await login(identificacion.trim(), password);
      navigate("/");
    } catch (error) {
      const data = error?.response?.data || {};

      // Cuenta creada desde "Crear cuenta" que el administrador aún no
      // aprueba (o rechazó): el backend responde 403 con `estado`.
      if (data.estado === "pendiente") {
        Swal.fire({
          icon: "info",
          title: "Cuenta pendiente de aprobación",
          text: data.error || "Tu solicitud ya fue recibida. Podrás ingresar cuando el administrador la apruebe.",
          confirmButtonColor: "#1a3a5c",
        });
        return;
      }
      if (data.estado === "rechazado") {
        Swal.fire({
          icon: "warning",
          title: "Solicitud no aprobada",
          text: data.error || "Tu solicitud de cuenta no fue aprobada. Comunícate con el administrador.",
          confirmButtonColor: "#1a3a5c",
        });
        return;
      }

      Swal.fire({
        icon: "error",
        title: "No se pudo iniciar sesión",
        text: error?.response
          ? data.error || "Verifica tu identificación y contraseña."
          : "No hay conexión con el servidor. Revisa tu internet e inténtalo de nuevo.",
        confirmButtonColor: "#1a3a5c",
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AuthShell
      titulo="Sistema Integrado de Promoción Social"
      texto="Registro y seguimiento de las estrategias de Promoción Social en el departamento del Amazonas, con o sin conexión."
      extra={
        <div className="auth-estrategias">
          {ESTRATEGIAS.map((e) => <span key={e}>{e}</span>)}
        </div>
      }
    >
      <h2>Iniciar sesión</h2>
      <div className="auth-sub">Ingresa con tu número de identificación.</div>

      <Form onSubmit={manejarSubmit} noValidate={false}>
        <Form.Group className="mb-3" controlId="login-identificacion">
          <Form.Label>Número de identificación</Form.Label>
          <Form.Control
            type="text"
            inputMode="numeric"
            autoComplete="username"
            placeholder="Ej. 1121234567"
            value={identificacion}
            onChange={(e) => setIdentificacion(e.target.value)}
            required
            autoFocus
          />
        </Form.Group>

        <Form.Group className="mb-2" controlId="login-password">
          <Form.Label>Contraseña</Form.Label>
          <CampoPassword
            autoComplete="current-password"
            placeholder="Tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>

        <div className="text-end mb-3">
          <Link to="/restablecer-password" className="auth-link" style={{ fontSize: "0.8rem" }}>
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <Button type="submit" className="w-100 btn-ps auth-btn" disabled={enviando}>
          {enviando ? "Ingresando..." : "Ingresar"}
        </Button>
      </Form>

      <div className="auth-separador">¿Aún no tienes cuenta?</div>

      <Button as={Link} to="/registro" variant="outline-secondary" className="w-100 auth-btn" style={{ borderColor: "#d5dce6", color: "#1a3a5c" }}>
        Crear cuenta
      </Button>
      <div className="text-center mt-2" style={{ fontSize: "0.76rem", color: "#8a94a3" }}>
        Tu cuenta quedará activa cuando el administrador la apruebe.
      </div>
    </AuthShell>
  );
}
